export function buildAssessmentResultName(assessmentDetail: any): string {
	return [
		assessmentDetail?.subProject?.project?.projectName?.trim(),
		assessmentDetail?.subProject?.subProjectName?.trim(),
		assessmentDetail?.assessmentName?.trim(),
		assessmentDetail?.developmentStage?.valueTxt?.trim(),
	]
		.filter((value) => !!value)
		.join("/")
}

export function parseDuplicateResultResponse(response?: string | null): { name: string; path: string } | null {
	if (!response || !response.startsWith("duplicateName|")) {
		return null
	}

	const [, name, path] = response.split("|")
	if (!name || !path) {
		return null
	}

	return { name, path }
}
